(() => {
  if (customElements.get('lp-offer-picker')) return;

  const ANSWERS_KEY = 'zkQuizAnswers';

  class LpOfferPicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.cta = this.querySelector('[data-offer-cta]');

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-offer-input]')) this.update();
      });

      if (this.cta) this.cta.addEventListener('click', (event) => this.onCheckoutClick(event));

      if (!this.selected) {
        const first = this.querySelector('[data-offer-input]:not(:disabled)');
        if (first) first.checked = true;
      }

      this.update();
      if (this.id) this.bindAnchorLinks();
    }

    get selected() {
      return this.querySelector('[data-offer-input]:checked');
    }

    update() {
      const input = this.selected;

      this.querySelectorAll('[data-offer-option]').forEach((option) => {
        option.classList.toggle('is-selected', Boolean(input) && option.contains(input));
      });

      if (!this.cta) return;

      if (!input) {
        this.cta.setAttribute('aria-disabled', 'true');
        return;
      }

      this.cta.removeAttribute('aria-disabled');
      this.cta.href = this.buildCheckoutUrl(input.value, input.dataset.quantity || 1);
    }

    buildCheckoutUrl(variantId, quantity) {
      const url = new URL(`${this.dataset.cartUrl}/${variantId}:${quantity}`, window.location.origin);

      if (this.dataset.discount) url.searchParams.set('discount', this.dataset.discount);

      if (this.hasAttribute('data-pass-answers')) {
        const stored = this.readAnswers();
        if (stored && stored.answers && Object.keys(stored.answers).length) {
          if (stored.quiz) url.searchParams.set('attributes[quiz]', stored.quiz);
          Object.entries(stored.answers).forEach(([key, value]) => {
            url.searchParams.set(`attributes[quiz_${key}]`, value);
          });
        }
      }

      return url.toString();
    }

    readAnswers() {
      try {
        return JSON.parse(sessionStorage.getItem(ANSWERS_KEY) || 'null');
      } catch (error) {
        return null;
      }
    }

    onCheckoutClick(event) {
      const input = this.selected;
      if (!input) {
        event.preventDefault();
        return;
      }

      this.update();

      const payload = {
        variant_id: input.value,
        quantity: Number(input.dataset.quantity || 1),
        value: Number(input.dataset.price || 0) / 100,
        currency: this.dataset.currency,
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'offer_checkout_click', ...payload });

      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('offer_checkout_click', payload);
        }
      } catch (error) {}
    }

    bindAnchorLinks() {
      document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href*="#"]');
        if (!link) return;

        const url = new URL(link.href, window.location.href);
        if (url.hash !== `#${this.id}` || url.pathname !== window.location.pathname) return;

        event.preventDefault();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  customElements.define('lp-offer-picker', LpOfferPicker);
})();
